function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_dd)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_d)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 18,
  y: 13,
  width: 104.852,
  height: 78.5403,
  rx: 4.63087,
  fill: "#E4E4E4"
}), /*#__PURE__*/React.createElement("rect", {
  x: 18.35,
  y: 13.35,
  width: 104.152,
  height: 77.8403,
  rx: 4.28087,
  stroke: "#4D20B2",
  strokeWidth: 0.7
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter2_d)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 70,
  cy: 52.3171,
  rx: 27,
  ry: 28.3171,
  fill: "white"
})), /*#__PURE__*/React.createElement("path", {
  d: "M69.9999 71.4147C69.0263 71.4147 68.1918 71.054 67.4963 70.3326C66.8009 69.6112 66.4532 68.7599 66.4532 67.7788H73.5465C73.5465 68.7599 73.1988 69.6112 72.5034 70.3326C71.808 71.054 70.9735 71.4147 69.9999 71.4147ZM81.5578 60.3339L85.1462 64.0564V65.8743H54.8535V64.0564L58.4419 60.3339V50.2055C58.4419 47.3776 59.2764 44.8815 60.9454 42.7173C62.6145 40.5531 64.7285 39.1536 67.2877 38.5188V37.3068C67.2877 36.4988 67.552 35.8351 68.0805 35.3157C68.609 34.7963 69.2488 34.5366 69.9999 34.5366C70.7509 34.5366 71.3768 34.7963 71.8775 35.3157C72.3782 35.8351 72.6286 36.4988 72.6286 37.3068V38.5188C75.2434 39.1536 77.3853 40.5531 79.0543 42.7173C80.7233 44.8815 81.5578 47.3776 81.5578 50.2055V60.3339Z",
  fill: "#652DD0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M78.4035 91.5398H62.4477V103H57.7C56.7611 103 56 103.761 56 104.7C56 105.639 56.7611 106.4 57.7 106.4H81.978C82.9169 106.4 83.678 105.639 83.678 104.7C83.678 103.761 82.9169 103 81.978 103H78.4035V91.5398Z",
  fill: "#652DD0"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter3_d)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 93.4297,
  y: 46.3208,
  width: 36.5717,
  height: 61.8802,
  rx: 2.1823,
  fill: "#94F7B8"
}), /*#__PURE__*/React.createElement("rect", {
  x: 93.9297,
  y: 46.8208,
  width: 35.5717,
  height: 60.8802,
  rx: 1.6823,
  stroke: "#007E6C"
})), /*#__PURE__*/React.createElement("rect", {
  x: 105.998,
  y: 102.25,
  width: 11.4287,
  height: 3.57001,
  rx: 1.78501,
  fill: "#652DD0"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter4_d)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 111.662,
  cy: 77.2601,
  rx: 10.2572,
  ry: 10.71,
  fill: "white"
})), /*#__PURE__*/React.createElement("path", {
  d: "M111.66 82.2028C111.406 82.2028 111.189 82.1061 111.008 81.9128C110.827 81.7194 110.736 81.4912 110.736 81.2281H112.584C112.584 81.4912 112.493 81.7194 112.312 81.9128C112.131 82.1061 111.914 82.2028 111.66 82.2028ZM114.67 79.2323L115.605 80.2302V80.7176H107.715V80.2302L108.649 79.2323V76.5171C108.649 75.759 108.867 75.0899 109.302 74.5097C109.736 73.9295 110.287 73.5544 110.954 73.3842V73.0593C110.954 72.8427 111.022 72.6648 111.16 72.5255C111.298 72.3863 111.464 72.3167 111.66 72.3167C111.856 72.3167 112.019 72.3863 112.149 72.5255C112.279 72.6648 112.345 72.8427 112.345 73.0593V73.3842C113.026 73.5544 113.584 73.9295 114.018 74.5097C114.453 75.0899 114.67 75.759 114.67 76.5171V79.2323Z",
  fill: "#652DD0"
})));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_dd",
  x: -26.0759,
  y: -22.1856,
  width: 200.153,
  height: 183.353,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4.72157
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 11.7042
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0282725 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8.8903
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 22.0379
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.035 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow",
  result: "effect2_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect2_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_d",
  x: 11.1,
  y: 9.55,
  width: 118.652,
  height: 92.3403,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 3.45
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3.45
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_d",
  x: 34.375,
  y: 18.825,
  width: 71.25,
  height: 73.8841,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 3.45
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4.3125
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter3_d",
  x: 81.3547,
  y: 37.6958,
  width: 53.8217,
  height: 79.1302,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -3.45
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4.3125
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter4_d",
  x: 95.4331,
  y: 62.9674,
  width: 32.4568,
  height: 33.3624,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2.38846
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2.98558
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 143,
  height: 130,
  fill: "white"
})));

var SvgNotoficationIcon = function SvgNotoficationIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 130,
    viewBox: "0 0 143 130",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNotoficationIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/notofication-icon.af652479.svg";
export { ForwardRef as ReactComponent };